module.exports = __webpack_public_path__ + "static/media/metrics-no-data.06e261a2.jpg";